'use client';

import React, { useState, useRef, useMemo, useCallback } from 'react';
import { useClickAway } from 'react-use';
import { SearchLine as BaseSearchLine } from '@org/ui';
import { Input } from '@/components/ui/input';
import { useLanguage } from '@/lib/config/useLanguage';
import { buildLanguagePath } from '@/lib/config/utils';
import { cn } from '@/lib/utils';

// Кастомный Input для десктопной версии с нужными стилями
// Выносим за пределы компонента, чтобы избежать пересоздания при каждом рендере
const DesktopInput = React.forwardRef((props, ref) => (
    <Input
        {...props}
        ref={ref}
        className={cn(
            'relative rounded-2xl outline-none w-full bg-gray-100 pr-12 h-11',
            'border-0 focus:ring-0 focus:outline-none',
            props.className
        )}
    />
));
DesktopInput.displayName = 'DesktopInput';

export default function SearchLineModal() {
    const [query, setQuery] = useState('');
    const [focused, setFocused] = useState(false);
    const ref = useRef(null);

    const { tf, langCode } = useLanguage();

    // Мемоизируем функцию для построения пути с учетом языка
    const buildPath = useCallback((path) => {
        return buildLanguagePath(langCode, path);
    }, [langCode]);

    // Мемоизируем переводы
    const translations = useMemo(() => ({
        placeholder: tf('placeholders', 'search'),
    }), [tf]);

    useClickAway(ref, () => {
        setFocused(false);
    });

    return (
        <div
            ref={ref}
            className="hidden md:flex rounded-2xl flex-1 justify-between relative z-50 pointer-events-auto items-center mx-3"
        >
            <BaseSearchLine
                value={query}
                onChange={setQuery}
                translations={translations}
                buildPath={buildPath}
                InputComponent={DesktopInput}
                className="w-full"
            />
            {/* TODO: Добавить отображение подсказок при focused */}
        </div>
    );
}
